import { Oferta } from './oferta';

export class Login {

    public oferta: Oferta;
    public documentIdentificatiu: string;
    public dataNaixement: string;
    public acceptaLopd = false;

    constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/lib/model/login.ts